import { render, staticRenderFns } from "./LocationViewInfoCards.vue?vue&type=template&id=63b43397&lang=true"
import script from "./LocationViewInfoCards.vue?vue&type=script&lang=js"
export * from "./LocationViewInfoCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports